import { BASE_URL } from "../helpers/constants"
import { clearTokens, getAccessToken, getTokenRemainingTime } from "./jwt"
import { inBrowser } from "@omnichannel/ace-b2b-elements"

// const inBrowser = !!(
//   typeof window !== "undefined" &&
//   window.document &&
//   window.document.createElement
// )

const getBranches = () => {
  let branches = []
  if (inBrowser) {
    branches = localStorage.getItem('branches') ? localStorage.getItem('branches') : []
  }
  return branches
}

const setBranches = (list) => {
  localStorage.setItem('branches', list)
}

const getCompanyId = () => {
  let companyId = ''
  if (inBrowser) {
    companyId = localStorage.getItem('company-id')
  }
  return companyId
}

const getUserEmail = () => {
  let email = ''
  if (inBrowser) {
    email = localStorage.getItem('user-email')
  }
  return email
}

const trimText = (string, dimension, defaultCharCount = 0) => {
  const windowWidth = dimension
  let frame320 = windowWidth && windowWidth <= 320
  let frame360 = windowWidth && windowWidth <= 360
  let frame375 = windowWidth && windowWidth <= 375
  let frame412 = windowWidth && windowWidth <= 412
  let frame550 = windowWidth && windowWidth <= 550
  let frame768 = windowWidth && windowWidth <= 768
  let frame900 = windowWidth && windowWidth <= 900
  let frame1280 = windowWidth && windowWidth <= 1280
  let frame1360 = windowWidth && windowWidth <= 1360
  let frame1360Above = windowWidth && windowWidth > 1360

  let charCount = 55
  if (frame320) {
    charCount = 20
  } else if (frame360) {
    charCount = 30
  } else if (frame375) {
    charCount = 32
  } else if (frame412) {
    charCount = 32
  } else if (frame550) {
    charCount = 35
  } else if (frame768) {
    charCount = 40
  } else if (frame900) {
    charCount = 25
  } else if (frame1280) {
    charCount = 35
  } else if (frame1360) {
    charCount = 40
  } else if (frame1360Above) {
    charCount = 45
  }
  if (defaultCharCount > 0) {
    charCount = defaultCharCount
  }
  if (string && string.length <= charCount) {
    return string
  }
  return string && `${string.substring(0, charCount)}...`
}

// const getFormattedCurrency = value => {
//   var formattedNumber = (Math.round(value * 100) / 100).toFixed(2)
//   var price = formattedNumber.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")

//   return price
// }

const sortSize = (a, b) => {
  const sizeSort = ["XS", "S", "M", "L", "XL"]
  const ageSort = ["3-6mos", "6-9mos", "9-12mos", "12-18mos"]

  if (sizeSort.indexOf(a) > -1) {
    return sizeSort.indexOf(a) - sizeSort.indexOf(b)
  } else if (ageSort.indexOf(a) > -1) {
    return ageSort.indexOf(a) - ageSort.indexOf(b)
  } else {
    return a - b
  }
}

const isAuthenticated = () => {
  if (inBrowser) {
    if (localStorage.getItem("access-token")) {
      return true
    } else {
      localStorage.removeItem("company-id")
      localStorage.removeItem("user-email")
      localStorage.removeItem("user-name")
      localStorage.removeItem("access-token")
      localStorage.removeItem("refresh-token")
      return false
    }
  }
  return false
}

const groupBy = (array, key) => {
  return array.reduce((result, currentValue) => {
    ; (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    )

    return result
  }, {})
}

const groupByNameAndParent = categories => {
  let groupedArray = []
  const cloned = JSON.parse(JSON.stringify(categories))

  cloned.forEach(category => {
    const existing = groupedArray.filter(
      mapItem =>
        mapItem.name === category.name && mapItem.parent === category.parent
    )
    if (existing.length > 0) {
      const existingIndex = groupedArray.indexOf(existing[0])
      groupedArray[existingIndex]._id.push(category._id)
      groupedArray[existingIndex].count =
        groupedArray[existingIndex].count + category.count
    } else {
      category._id = [category._id]
      groupedArray = [...groupedArray, category]
    }
  })

  return groupedArray
}

const removeDuplicates = (array, key) => {
  let filteredArray = []

  array.forEach(item => {
    const existing = filteredArray.filter(added => added[key] === item[key])
    if (existing.length === 0) {
      filteredArray.push(item)
    }
  })

  return filteredArray
}

const getSearchKeywordFromURI = path => {
  if (path) {
    return decodeURIComponent(path.split("=")[1])
  }
  return ""
}

const keyById = array => {
  return array.reduce((obj, item) => {
    obj[item._id] = item
    return obj
  }, {})
}

const handleColor = color => {
  if (color && color.charAt(0) !== "#") {
    return "#" + color
  }
  return color
}

const redirectOnTokenExpiration = (url = BASE_URL) => {
  try {
    const accessToken = getAccessToken()
    if (accessToken) {
      const remainingTime = getTokenRemainingTime(accessToken)
      const oneMinute = 60 // value in seconds
      if (remainingTime < oneMinute) {
        clearTokens()
        window.location.replace(url)
      }
    }
  } catch (err) {
    throw err
  }
}

var isIE = inBrowser && (false || !!document.documentMode)
var isEdge = inBrowser && !isIE && !!window.StyleMedia

const formatString = string => {
  let stringArray = string.split(" ")
  stringArray = stringArray.map(s => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
  })
  return stringArray.join(" ")
}

export {
  // inBrowser,
  trimText,
  // getFormattedCurrency,
  sortSize,
  isAuthenticated,
  groupBy,
  groupByNameAndParent,
  removeDuplicates,
  getSearchKeywordFromURI,
  keyById,
  handleColor,
  redirectOnTokenExpiration,
  isEdge,
  isIE,
  formatString,
  getCompanyId,
  getUserEmail,
  setBranches,
  getBranches
}
